<template>
  <div class="dash">
    <div class="dash-header">
      <div>
        <div class="dash-hello">Olá{{ accountName ? ', ' + accountName : '' }} 👋</div>
        <div class="dash-sub">Aqui está o resumo da sua conta</div>
      </div>
    </div>

    <v-layout row wrap>
      <v-flex xs12 md7 class="pa-2">
        <wallet />
      </v-flex>
      <v-flex xs12 md5 class="pa-2">
        <partner-data />
      </v-flex>

      <v-flex xs12 md5 class="pa-2">
        <overdraft />
      </v-flex>

      <v-flex xs12 class="pa-2">
        <calendar />
      </v-flex>

      <v-flex xs12 class="pa-2">
        <charts />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import "chartist/dist/chartist.min.css";
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  computed: {
    ...mapGetters({
      account: "account/account",
    }),
    accountName() {
      return (this.account && (this.account.fantasy_name || this.account.name)) || "";
    },
  },
  components: {
    Calendar: () => import("./Calendar.vue"),
    Charts: () => import("./Charts.vue"),
    Wallet: () => import("./Wallet.vue"),
    PartnerData: () => import("./PartnerData.vue"),
    Overdraft: () => import("./Overdraft.vue"),
  },
};
</script>

<style scoped>
.dash {
  padding: 8px 6px 32px;
  overflow-x: hidden;
}
/* Let flex items shrink below their content width so charts never force
   horizontal overflow on small screens. */
.dash >>> .flex {
  min-width: 0;
}
.dash-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px 16px;
}
.dash-hello {
  font-size: 22px;
  font-weight: 800;
  color: #1f2733;
}
.dash-sub {
  font-size: 14px;
  color: #8a94a6;
  margin-top: 2px;
}
</style>
